import { BaseDto } from '@/shared/dtos/base-dto';

export class VersionBack extends BaseDto {
    public version !: string;
    public descripcion !: string;

 } 
